const loanDenialContainerStyles = theme => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const loanDenialTopHeaderStyles = theme => ({
  display: 'flex',
  alignItems: 'stretch',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    '& > *': {
      padding: '10px 5px',
    },
    '& > *:nth-of-type(3), & > *:last-of-type': {
      borderLeft: `2px solid ${theme.palette.divider}`,
      paddingLeft: '5px',
      marginLeft: '5px',
    },
  },
});

const loanDenialSideHeaderStyles = theme => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    width: '40%',
    '& > *': {
      width: '100%',
      height: '2em',
    },
  },
});

const loanDenialRowStyles = theme => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    '&:not(:last-child)': {
      borderBottom: `2px solid ${theme.palette.divider}`,
      paddingBottom: '10px',
      marginBottom: '10px',
    },
    '& .deleteAction': {
      display: 'none',
    },
  },
});

const loanDenialRowDataStyles = theme => ({
  color: theme.palette.primary['100'],
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    alignItems: 'stretch',
    '& > *': {
      padding: '15px 5px',
    },
    '& > div:nth-of-type(3), & > div:last-of-type': {
      borderLeft: `2px solid ${theme.palette.divider}`,
      paddingLeft: '5px',
      marginLeft: '5px',
    },
  },
  [theme.breakpoints.down('md')]: {
    width: '50%',
    '& > *': {
      width: 'auto',
      height: '2em',
      display: 'block',
    },
  },
});

const loanDenialMobileRowActionsStyles = theme => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
});

const loanDenialCellWithCheckboxStyles = theme => ({
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    textAlign: 'left',
  },
  [theme.breakpoints.up('lg')]: {},
  '& label': {
    margin: 0,
    '& span': {
      padding: 0,
    },
  },
});

const loanDenialCheckboxStyles = {
  display: 'block',
  '& .Mui-error': {
    whiteSpace: 'nowrap',
    position: 'absolute',
    width: 'min(300px, 200%)',
    textAlign: 'center',
  },
};

export const getLoanDenialStyles = () => ({
  container: loanDenialContainerStyles,
  topHeader: loanDenialTopHeaderStyles,
  sideHeader: loanDenialSideHeaderStyles,
  row: loanDenialRowStyles,
  rowData: loanDenialRowDataStyles,
  mobileRowActions: loanDenialMobileRowActionsStyles,
  cellWithCheckbox: loanDenialCellWithCheckboxStyles,
  checkbox: loanDenialCheckboxStyles,
});
